"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.immunosuppressionMessages = exports.backupRecipientMessages = exports.venoVenousBypassMessages = exports.cellSaverUsePlannedMessages = exports.estimatedBloodLossMessages = exports.arterialConduitPlannedMessages = exports.arterialPressureMonitoringPlannedMessages = exports.splenicArteryAneurysmMessages = exports.hepaticArterialAnatomyTypeMessages = exports.arterialSupplyMessages = exports.portalVeinThrombosisGradeMessages = exports.portalCirculationMessages = exports.caudateLobeMessages = exports.liverSizeMessages = exports.Immunosuppression = exports.BackupRecipient = exports.VenoVenousBypass = exports.CellSaverUsePlanned = exports.EstimatedBloodLoss = exports.ArterialConduitPlanned = exports.ArterialPressureMonitoringPlanned = exports.SplenicArteryAneurysm = exports.HepaticArterialAnatomyType = exports.ArterialSupply = exports.PortalVeinThrombosisGrade = exports.PortalCirculation = exports.CaudateLobe = exports.LiverSize = void 0;
const schema_1 = require("../../schema");
var LiverSize;
(function (LiverSize) {
    LiverSize["SMALL"] = "SMALL";
    LiverSize["NORMAL"] = "NORMAL";
    LiverSize["ENLARGED"] = "ENLARGED";
    LiverSize["MARKEDLY_ENLARGED"] = "MARKEDLY ENLARGED";
})(LiverSize || (exports.LiverSize = LiverSize = {}));
var CaudateLobe;
(function (CaudateLobe) {
    CaudateLobe["SMALL"] = "SMALL";
    CaudateLobe["NORMAL"] = "NORMAL";
    CaudateLobe["ENLARGED"] = "ENLARGED";
})(CaudateLobe || (exports.CaudateLobe = CaudateLobe = {}));
var PortalCirculation;
(function (PortalCirculation) {
    PortalCirculation["INTACT"] = "INTACT";
    PortalCirculation["ABNORMAL"] = "ABNORMAL";
})(PortalCirculation || (exports.PortalCirculation = PortalCirculation = {}));
var PortalVeinThrombosisGrade;
(function (PortalVeinThrombosisGrade) {
    PortalVeinThrombosisGrade["GRADE_I"] = "GRADE_I";
    PortalVeinThrombosisGrade["GRADE_II"] = "GRADE_II";
    PortalVeinThrombosisGrade["GRADE_III"] = "GRADE_III";
    PortalVeinThrombosisGrade["GRADE_IV"] = "GRADE_IV";
    PortalVeinThrombosisGrade["OTHER"] = "OTHER";
})(PortalVeinThrombosisGrade || (exports.PortalVeinThrombosisGrade = PortalVeinThrombosisGrade = {}));
var ArterialSupply;
(function (ArterialSupply) {
    ArterialSupply["STANDARD"] = "STANDARD";
    ArterialSupply["VARIANT"] = "VARIANT";
})(ArterialSupply || (exports.ArterialSupply = ArterialSupply = {}));
var HepaticArterialAnatomyType;
(function (HepaticArterialAnatomyType) {
    HepaticArterialAnatomyType["TYPE_I"] = "TYPE_I";
    HepaticArterialAnatomyType["TYPE_II"] = "TYPE_II";
    HepaticArterialAnatomyType["TYPE_III"] = "TYPE_III";
    HepaticArterialAnatomyType["TYPE_IV"] = "TYPE_IV";
    HepaticArterialAnatomyType["TYPE_V"] = "TYPE_V";
    HepaticArterialAnatomyType["TYPE_VI"] = "TYPE_VI";
    HepaticArterialAnatomyType["TYPE_VII"] = "TYPE_VII";
    HepaticArterialAnatomyType["TYPE_VIII"] = "TYPE_VIII";
    HepaticArterialAnatomyType["TYPE_IX"] = "TYPE_IX";
    HepaticArterialAnatomyType["TYPE_X"] = "TYPE_X";
    HepaticArterialAnatomyType["OTHER"] = "OTHER";
})(HepaticArterialAnatomyType || (exports.HepaticArterialAnatomyType = HepaticArterialAnatomyType = {}));
var SplenicArteryAneurysm;
(function (SplenicArteryAneurysm) {
    SplenicArteryAneurysm["YES"] = "YES";
    SplenicArteryAneurysm["NO"] = "NO";
})(SplenicArteryAneurysm || (exports.SplenicArteryAneurysm = SplenicArteryAneurysm = {}));
var ArterialPressureMonitoringPlanned;
(function (ArterialPressureMonitoringPlanned) {
    ArterialPressureMonitoringPlanned["YES"] = "YES";
    ArterialPressureMonitoringPlanned["NO"] = "NO";
})(ArterialPressureMonitoringPlanned || (exports.ArterialPressureMonitoringPlanned = ArterialPressureMonitoringPlanned = {}));
var ArterialConduitPlanned;
(function (ArterialConduitPlanned) {
    ArterialConduitPlanned["YES"] = "YES";
    ArterialConduitPlanned["NO"] = "NO";
})(ArterialConduitPlanned || (exports.ArterialConduitPlanned = ArterialConduitPlanned = {}));
var EstimatedBloodLoss;
(function (EstimatedBloodLoss) {
    EstimatedBloodLoss["SMALL"] = "SMALL";
    EstimatedBloodLoss["NORMAL"] = "NORMAL";
    EstimatedBloodLoss["LARGE"] = "LARGE";
})(EstimatedBloodLoss || (exports.EstimatedBloodLoss = EstimatedBloodLoss = {}));
var CellSaverUsePlanned;
(function (CellSaverUsePlanned) {
    CellSaverUsePlanned["YES"] = "YES";
    CellSaverUsePlanned["NO"] = "NO";
})(CellSaverUsePlanned || (exports.CellSaverUsePlanned = CellSaverUsePlanned = {}));
var VenoVenousBypass;
(function (VenoVenousBypass) {
    VenoVenousBypass["YES"] = "YES";
    VenoVenousBypass["NO"] = "NO";
})(VenoVenousBypass || (exports.VenoVenousBypass = VenoVenousBypass = {}));
var BackupRecipient;
(function (BackupRecipient) {
    BackupRecipient["YES"] = "YES";
    BackupRecipient["NO"] = "NO";
})(BackupRecipient || (exports.BackupRecipient = BackupRecipient = {}));
var Immunosuppression;
(function (Immunosuppression) {
    Immunosuppression["STANDARD"] = "STANDARD";
    Immunosuppression["OTHER"] = "OTHER";
})(Immunosuppression || (exports.Immunosuppression = Immunosuppression = {}));
exports.liverSizeMessages = {
    [LiverSize.SMALL]: {
        id: "ltx.greenLight.liverSize.SMALL",
        defaultMessage: "Kicsi"
    },
    [LiverSize.NORMAL]: {
        id: "ltx.greenLight.liverSize.NORMAL",
        defaultMessage: "Normál"
    },
    [LiverSize.ENLARGED]: {
        id: "ltx.greenLight.liverSize.ENLARGED",
        defaultMessage: "Megnagyobbodott"
    },
    [LiverSize.MARKEDLY_ENLARGED]: {
        id: "ltx.greenLight.liverSize.MARKEDLY_ENLARGED",
        defaultMessage: "Extrém nagy"
    }
};
exports.caudateLobeMessages = {
    [CaudateLobe.SMALL]: {
        id: "ltx.greenLight.caudateLobe.SMALL",
        defaultMessage: "Kicsi"
    },
    [CaudateLobe.NORMAL]: {
        id: "ltx.greenLight.caudateLobe.NORMAL",
        defaultMessage: "Normál"
    },
    [CaudateLobe.ENLARGED]: {
        id: "ltx.greenLight.caudateLobe.ENLARGED",
        defaultMessage: "Megnagyobbodott"
    }
};
exports.portalCirculationMessages = {
    [PortalCirculation.INTACT]: {
        id: "ltx.greenLight.portalCirculation.INTACT",
        defaultMessage: "Intact"
    },
    [PortalCirculation.ABNORMAL]: {
        id: "ltx.greenLight.portalCirculation.ABNORMAL",
        defaultMessage: "Problémás"
    }
};
exports.portalVeinThrombosisGradeMessages = {
    [PortalVeinThrombosisGrade.GRADE_I]: {
        id: "ltx.greenLight.portalVeinThrombosisGrade.GRADE_I",
        defaultMessage: "Grade I"
    },
    [PortalVeinThrombosisGrade.GRADE_II]: {
        id: "ltx.greenLight.portalVeinThrombosisGrade.GRADE_II",
        defaultMessage: "Grade II"
    },
    [PortalVeinThrombosisGrade.GRADE_III]: {
        id: "ltx.greenLight.portalVeinThrombosisGrade.GRADE_III",
        defaultMessage: "Grade III"
    },
    [PortalVeinThrombosisGrade.GRADE_IV]: {
        id: "ltx.greenLight.portalVeinThrombosisGrade.GRADE_IV",
        defaultMessage: "Grade IV"
    },
    [PortalVeinThrombosisGrade.OTHER]: {
        id: "ltx.greenLight.portalVeinThrombosisGrade.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.arterialSupplyMessages = {
    [ArterialSupply.STANDARD]: {
        id: "ltx.greenLight.arterialSupply.STANDARD",
        defaultMessage: "Szokásos"
    },
    [ArterialSupply.VARIANT]: {
        id: "ltx.greenLight.arterialSupply.VARIANT",
        defaultMessage: "Variációs"
    }
};
exports.hepaticArterialAnatomyTypeMessages = {
    [HepaticArterialAnatomyType.TYPE_I]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_I",
        defaultMessage: "Type I"
    },
    [HepaticArterialAnatomyType.TYPE_II]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_II",
        defaultMessage: "Type II"
    },
    [HepaticArterialAnatomyType.TYPE_III]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_III",
        defaultMessage: "Type III"
    },
    [HepaticArterialAnatomyType.TYPE_IV]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_IV",
        defaultMessage: "Type IV"
    },
    [HepaticArterialAnatomyType.TYPE_V]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_V",
        defaultMessage: "Type V"
    },
    [HepaticArterialAnatomyType.TYPE_VI]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_VI",
        defaultMessage: "Type VI"
    },
    [HepaticArterialAnatomyType.TYPE_VII]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_VII",
        defaultMessage: "Type VII"
    },
    [HepaticArterialAnatomyType.TYPE_VIII]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_VIII",
        defaultMessage: "Type VIII"
    },
    [HepaticArterialAnatomyType.TYPE_IX]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_IX",
        defaultMessage: "Type IX"
    },
    [HepaticArterialAnatomyType.TYPE_X]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.TYPE_X",
        defaultMessage: "Type X"
    },
    [HepaticArterialAnatomyType.OTHER]: {
        id: "ltx.greenLight.hepaticArterialAnatomyType.OTHER",
        defaultMessage: "Egyéb"
    }
};
exports.splenicArteryAneurysmMessages = {
    [SplenicArteryAneurysm.YES]: {
        id: "ltx.greenLight.splenicArteryAneurysm.YES",
        defaultMessage: "Igen"
    },
    [SplenicArteryAneurysm.NO]: {
        id: "ltx.greenLight.splenicArteryAneurysm.NO",
        defaultMessage: "Nem"
    }
};
exports.arterialPressureMonitoringPlannedMessages = {
    [ArterialPressureMonitoringPlanned.YES]: {
        id: "ltx.greenLight.arterialPressureMonitoringPlanned.YES",
        defaultMessage: "Igen"
    },
    [ArterialPressureMonitoringPlanned.NO]: {
        id: "ltx.greenLight.arterialPressureMonitoringPlanned.NO",
        defaultMessage: "Nem"
    }
};
exports.arterialConduitPlannedMessages = {
    [ArterialConduitPlanned.YES]: {
        id: "ltx.greenLight.arterialConduitPlanned.YES",
        defaultMessage: "Igen"
    },
    [ArterialConduitPlanned.NO]: {
        id: "ltx.greenLight.arterialConduitPlanned.NO",
        defaultMessage: "Nem"
    }
};
exports.estimatedBloodLossMessages = {
    [EstimatedBloodLoss.SMALL]: {
        id: "ltx.greenLight.estimatedBloodLoss.SMALL",
        defaultMessage: "Kicsi"
    },
    [EstimatedBloodLoss.NORMAL]: {
        id: "ltx.greenLight.estimatedBloodLoss.NORMAL",
        defaultMessage: "Közepes"
    },
    [EstimatedBloodLoss.LARGE]: {
        id: "ltx.greenLight.estimatedBloodLoss.LARGE",
        defaultMessage: "Nagy"
    }
};
exports.cellSaverUsePlannedMessages = {
    [CellSaverUsePlanned.YES]: {
        id: "ltx.greenLight.cellSaverUsePlanned.YES",
        defaultMessage: "Igen"
    },
    [CellSaverUsePlanned.NO]: {
        id: "ltx.greenLight.cellSaverUsePlanned.NO",
        defaultMessage: "Nem"
    }
};
exports.venoVenousBypassMessages = {
    [VenoVenousBypass.YES]: {
        id: "ltx.greenLight.venoVenousBypass.YES",
        defaultMessage: "Igen"
    },
    [VenoVenousBypass.NO]: {
        id: "ltx.greenLight.venoVenousBypass.NO",
        defaultMessage: "Nem"
    }
};
exports.backupRecipientMessages = {
    [BackupRecipient.YES]: {
        id: "ltx.greenLight.backupRecipient.YES",
        defaultMessage: "Igen"
    },
    [BackupRecipient.NO]: {
        id: "ltx.greenLight.backupRecipient.NO",
        defaultMessage: "Nem"
    }
};
exports.immunosuppressionMessages = {
    [Immunosuppression.STANDARD]: {
        id: "ltx.greenLight.immunosuppression.STANDARD",
        defaultMessage: "Szokásos"
    },
    [Immunosuppression.OTHER]: {
        id: "ltx.greenLight.immunosuppression.OTHER",
        defaultMessage: "Egyéb"
    }
};
const liverSize = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(LiverSize.SMALL),
    schema_1.Schema.singleChoiceItem(LiverSize.NORMAL),
    schema_1.Schema.singleChoiceItem(LiverSize.ENLARGED),
    schema_1.Schema.singleChoiceItem(LiverSize.MARKEDLY_ENLARGED)
]).interpretation({ vocab: "ltx", code: "liver_size" });
const caudateLobe = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CaudateLobe.SMALL),
    schema_1.Schema.singleChoiceItem(CaudateLobe.NORMAL),
    schema_1.Schema.singleChoiceItem(CaudateLobe.ENLARGED)
]).interpretation({ vocab: "ltx", code: "caudate_lobe" });
const portalCirculation = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PortalCirculation.INTACT),
    schema_1.Schema.singleChoiceItem(PortalCirculation.ABNORMAL)
]).interpretation({ vocab: "ltx", code: "portal_circulation" });
const portalVeinThrombosisGrade = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(PortalVeinThrombosisGrade.GRADE_I),
    schema_1.Schema.singleChoiceItem(PortalVeinThrombosisGrade.GRADE_II),
    schema_1.Schema.singleChoiceItem(PortalVeinThrombosisGrade.GRADE_III),
    schema_1.Schema.singleChoiceItem(PortalVeinThrombosisGrade.GRADE_IV),
    schema_1.Schema.singleChoiceItem(PortalVeinThrombosisGrade.OTHER)
]).interpretation({ vocab: "ltx", code: "portal_vein_thrombosis_grade" });
const portalVeinThrombosisComment = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({
    vocab: "ltx",
    code: "portal_vein_thrombosis_grade_comment"
});
const arterialSupply = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArterialSupply.STANDARD),
    schema_1.Schema.singleChoiceItem(ArterialSupply.VARIANT)
]).interpretation({ vocab: "ltx", code: "arterial_supply" });
const hepaticArterialAnatomyType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_I),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_II),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_III),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_IV),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_V),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_VI),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_VII),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_VIII),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_IX),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.TYPE_X),
    schema_1.Schema.singleChoiceItem(HepaticArterialAnatomyType.OTHER)
]).interpretation({ vocab: "ltx", code: "hepatic_arterial_anatomy_type" });
const hepaticArterialAnatomyComment = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({
    vocab: "ltx",
    code: "hepatic_arterial_anatomy_type_comment"
});
const splenicArteryAneurysm = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(SplenicArteryAneurysm.YES),
    schema_1.Schema.singleChoiceItem(SplenicArteryAneurysm.NO)
]).interpretation({ vocab: "ltx", code: "splenic_artery_aneurysm" });
const arterialPressureMonitoringPlanned = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArterialPressureMonitoringPlanned.YES),
    schema_1.Schema.singleChoiceItem(ArterialPressureMonitoringPlanned.NO)
]).interpretation({
    vocab: "ltx",
    code: "arterial_pressure_monitoring_planned"
});
const arterialConduitPlanned = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(ArterialConduitPlanned.YES),
    schema_1.Schema.singleChoiceItem(ArterialConduitPlanned.NO)
]).interpretation({ vocab: "ltx", code: "arterial_conduit_planned" });
const estimatedBloodLoss = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(EstimatedBloodLoss.SMALL),
    schema_1.Schema.singleChoiceItem(EstimatedBloodLoss.NORMAL),
    schema_1.Schema.singleChoiceItem(EstimatedBloodLoss.LARGE)
]).interpretation({ vocab: "ltx", code: "estimated_blood_loss" });
const cellSaverUsePlanned = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(CellSaverUsePlanned.YES),
    schema_1.Schema.singleChoiceItem(CellSaverUsePlanned.NO)
]).interpretation({ vocab: "ltx", code: "cell_saver_use_planned" });
const venoVenousBypass = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(VenoVenousBypass.YES),
    schema_1.Schema.singleChoiceItem(VenoVenousBypass.NO)
]).interpretation({ vocab: "ltx", code: "veno-venous_bypass" });
const backupRecipient = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(BackupRecipient.YES),
    schema_1.Schema.singleChoiceItem(BackupRecipient.NO)
]).interpretation({ vocab: "ltx", code: "backup_recipient" });
const immunosuppression = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Immunosuppression.STANDARD),
    schema_1.Schema.singleChoiceItem(Immunosuppression.OTHER)
]).interpretation({ vocab: "ltx", code: "immunosuppression" });
const immunosuppressionOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../immunosuppression} === "OTHER"`), schema_1.Schema.string()
    .maxLength(1000)
    .interpretation({ vocab: "ltx", code: "immunosuppression_other" }));
const otherTechnicalDifficulties = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "ltx", code: "other_technical_difficulties" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    liverSize,
    caudateLobe,
    portalCirculation,
    portalVeinThrombosisGrade,
    portalVeinThrombosisComment,
    arterialSupply,
    hepaticArterialAnatomyType,
    hepaticArterialAnatomyComment,
    splenicArteryAneurysm,
    arterialPressureMonitoringPlanned,
    arterialConduitPlanned,
    estimatedBloodLoss,
    cellSaverUsePlanned,
    venoVenousBypass,
    backupRecipient,
    immunosuppression,
    immunosuppressionOther,
    otherTechnicalDifficulties
})
    .interpretation({ vocab: "ltx", code: "green_light" });
